import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface ScheduledMessageItem {
  schedule_id: string;
  to: string;
  message_type: string;
  payload: { body?: string; template_name?: string; [key: string]: unknown };
  from_number?: string;
  send_at: number;
  status: 'pending' | 'sent' | 'failed' | 'canceled';
  result?: unknown;
  created_at: number;
  sent_at?: number | null;
}

type QueryResponse = {
  status: number;
  data: {
    scheduled_messages: ScheduledMessageItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListScheduledMessagesKey = (additional: any[] = []) => [
  'list-scheduled-messages',
  ...additional,
];

export const useListScheduledMessagesQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing scheduled messages',
    endpoint: `/api/admin/whatsapp/scheduled`,
  });

  return useQuery({
    queryKey: createListScheduledMessagesKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
